export default "__VITE_ASSET__004da433__"